/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".slick-dots[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:0;line-height:0;display:block;width:20px;height:5px;padding:0;cursor:pointer;color:transparent;border:0;outline:0;background:silver}\n/*# sourceMappingURL=home.component.css.map*/"];
export { styles as styles };
